import "antd/lib/result/style";
import _Result from "antd/lib/result";
import 'antd/lib/result/style'; // import './style/index.less';

export default _Result;